import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const EmployeeDashboard = lazy(() => import('./EmployeeDashboard'));
const Employees = lazy(() => import('./Employees'));
const Attendance = lazy(() => import('./Attendance'));
const LeaveRequests = lazy(() => import('./LeaveRequests'));
const LeaveManagement = lazy(() => import('./LeaveManagement'));
const Payroll = lazy(() => import('./Payroll'));
const Recruiting = lazy(() => import('./Recruiting'));
const PerformanceReviews = lazy(() => import('./PerformanceReviews'));
const PerformanceReviewDetail = lazy(() => import('./PerformanceReviewDetail'));
const Training = lazy(() => import('./Training'));
const Departments = lazy(() => import('./Departments'));
const WorkShiftsRota = lazy(() => import('./WorkShiftsRota'));
const PerformanceDashboard = lazy(() => import('./PerformanceDashboard'));
const EmployeeTargets = lazy(() => import('./EmployeeTargets'));
const KpiSettings = lazy(() => import('./KpiSettings'));
const BiometricDevices = lazy(() => import('./BiometricDevices'));

export const hrRoutes = (
    <React.Fragment key="hr">
        <Route element={<ProtectedRoute permission="hr.employee.view" />}>
            <Route path="/employee-dashboard" element={<EmployeeDashboard />} />
            <Route path="/employees" element={<Employees />} />
        </Route>
        <Route element={<ProtectedRoute permission="hr.attendance.view" />}>
            <Route path="/attendance" element={<Attendance />} />
        </Route>
        <Route element={<ProtectedRoute permission="hr.leave.view" />}>
            <Route path="/hr/leave" element={<LeaveRequests />} />
            <Route path="/hr/leave-management" element={<LeaveManagement />} />
        </Route>
        <Route element={<ProtectedRoute permission="hr.payroll.manage" />}>
            <Route path="/payroll" element={<Payroll />} />
        </Route>
        <Route element={<ProtectedRoute permission="hr.recruiting.view" />}>
            <Route path="/hr/recruiting" element={<Recruiting />} />
        </Route>
        <Route element={<ProtectedRoute permission="hr.performance.view" />}>
            <Route path="/hr/performance" element={<PerformanceReviews />} />
            <Route path="/hr/performance/:id" element={<PerformanceReviewDetail />} />
            <Route path="/hr/performance-dashboard" element={<PerformanceDashboard />} />
            <Route path="/hr/targets" element={<EmployeeTargets />} />
        </Route>
        <Route element={<ProtectedRoute permission="hr.performance.configure" />}>
            <Route path="/hr/kpi-settings" element={<KpiSettings />} />
        </Route>
        <Route element={<ProtectedRoute permission="hr.training.view" />}>
            <Route path="/hr/training" element={<Training />} />
        </Route>
        <Route element={<ProtectedRoute permission="hr.department.view" />}>
            <Route path="/departments" element={<Departments />} />
        </Route>
        <Route element={<ProtectedRoute permission="hr.attendance.view" />}>
            <Route path="/hr/shifts" element={<WorkShiftsRota />} />
        </Route>
        <Route element={<ProtectedRoute permission="hr.biometric.view" />}>
            <Route path="/hr/biometric" element={<BiometricDevices />} />
        </Route>
    </React.Fragment>
);
